import { FC, useState } from "react";
import {
  Box,
  createStyles,
  IconButton,
  makeStyles,
  Snackbar,
  Typography,
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";

import theme from "theme";

const useStyles = makeStyles(theme =>
  createStyles({
    snackbar: {
      "& .MuiPaper-root": {
        [theme.breakpoints.down("xs")]: {
          maxWidth: 220,
        },
      },
    },
    notificationMessage: {
      maxWidth: 400,
      "& *": {
        textTransform: "none",
      },
    },
  }),
);

interface ExchangeNotificationSnackBarProps {
  title: string;
  message: string;
}

const ExchangeNotificationSnackBar: FC<ExchangeNotificationSnackBarProps> = ({
  title,
  message,
}) => {
  const classes = useStyles();
  const [isNotificationOpen, setIsNotificationOpen] = useState(true);

  const handleClose = () => setIsNotificationOpen(false);

  return (
    <Snackbar
      className={classes.snackbar}
      open={isNotificationOpen}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      message={
        <Box className={classes.notificationMessage}>
          <Typography variant="subtitle1" gutterBottom>
            <Box fontWeight={theme.typography.fontWeightMedium}>{title}</Box>
          </Typography>
          <Typography variant="body2">{message}</Typography>
        </Box>
      }
      action={
        <IconButton aria-label="close" color="inherit" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      }
    />
  );
};

export default ExchangeNotificationSnackBar;
